// import apartment from '../../area-apartment/routerApartment/apartment.js'
// import invoiceRouter from '../../area-dcits/routerDcits/invoiceRouter.js'
// import dcitsContract from '../../area-dcits/routerDcits/contract.js'
// import pay from '../../area-apartment/routerApartment/pay.js'
// import energe from '../../area-energyManage/energeRouter/index.js'
// import contract from '../routerContract/contract.js'
// import networkoperate from '../routerContract/networkoperate.js'
// import bill from '../routerContract/bill.js'
// // 首页待办
// import worfklowIndexRouter from '../../area-index-page/router/worfklowIndexRouter.js'
// // import mnangement from '../routerContract/mnangement.js'
// // import businessmanage from '../routerContract/businessmanage.js'
// import process from '../routerContract/process.js'

const ladyLoading = url => () => import(`../views/${url}.vue`)

// 租控管理
const serivceApp = ladyLoading('Home/serviceHome')
const routes = {
  appType: 0,
  children: Array(0),
  component: serivceApp,
  meta: {
    menuId: 'M1003---',
    noTab: true,
    sort: 4,
    type: 'menu',
    zhname: '服务'
  },
  name: 'serivceApp',
  path: 'serivceapp',
  title: '服务'
}

export default routes



// WEBPACK FOOTER //
// ./src/area-contract/router/service.js